// SPEC-097 (RNF-005) — formateador único de moneda compartido por todo el módulo.

export function formatMoneda(valor: number): string {
  const redondeado = Math.round(valor);
  const signo = redondeado < 0 ? '-' : '';
  const miles = new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.abs(redondeado));
  return `${signo}$ ${miles}`;
}

export function formatMonedaCompacta(valor: number): string {
  if (Math.abs(valor) < 1_000_000) {
    return formatMoneda(valor);
  }
  const millones = valor / 1_000_000;
  const texto = millones.toLocaleString('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return `$ ${texto} M`;
}

export function formatFecha(fecha: string | Date): string {
  const d = typeof fecha === 'string' ? new Date(fecha) : fecha;
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function diasHasta(fechaISO: string): number {
  const hoy = new Date();
  const inicioHoy = Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  const [y, m, d] = fechaISO.split('-').map(Number);
  const fecha = Date.UTC(y, m - 1, d);
  return Math.round((fecha - inicioHoy) / (1000 * 60 * 60 * 24));
}
